"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _uaoJs = require("uao-js");

var encode = function encode(str, charset) {
  var buffer;

  switch (charset) {
    case 'utf8':
    case 'utf-8':
      buffer = Buffer.from(str, 'utf8');
      break;

    case 'big5':
      buffer = Buffer.from((0, _uaoJs.encodeSync)(str), 'binary');
      break;

    default:
      throw new TypeError("Unknown charset: ".concat(charset));
  }

  return buffer;
};

var _default = encode;
exports["default"] = _default;